import Api from "../services/AxiosService";
import { unwrap } from "./envelope";
import type { FastenerBrandCode } from "./applications";

// ---------------------------------------------------------------------------
// Fastener brand options — GET /v1/filter-options/fastener-brands (svc-04)
// ---------------------------------------------------------------------------

export interface FastenerBrandOption {
  code: FastenerBrandCode;
  displayName: string;
  displayOrder: number;
}

export async function getFastenerBrands(): Promise<FastenerBrandOption[]> {
  const res = await Api.get("/v1/filter-options/fastener-brands");
  const payload = unwrap<unknown>(res.data);
  return Array.isArray(payload) ? (payload as FastenerBrandOption[]) : [];
}

// ---------------------------------------------------------------------------
// Fastener type catalog — GET /v1/catalogs/fasteners?brand=&q=&limit= (svc-04)
// ---------------------------------------------------------------------------

export interface FastenerCatalogItem {
  brand: FastenerBrandCode;
  typeCode: string;
  typeDisplay: string;
  source: string;
}

export interface FastenerCatalogQuery {
  brand: FastenerBrandCode;
  q?: string;
  limit?: number;
}

export async function searchFastenerCatalog(
  query: FastenerCatalogQuery,
): Promise<FastenerCatalogItem[]> {
  const params: Record<string, string | number> = { brand: query.brand };
  if (query.q) params.q = query.q;
  if (query.limit) params.limit = query.limit;
  const res = await Api.get("/v1/catalogs/fasteners", { params });
  return unwrap<FastenerCatalogItem[]>(res.data);
}
